import { render, staticRenderFns } from "./AddCardDialog.vue?vue&type=template&id=f10f4aba&lang=pug&"
import script from "./AddCardDialog.vue?vue&type=script&lang=ts&"
export * from "./AddCardDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddCardDialog.vue?vue&type=style&index=0&id=f10f4aba&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports